import * as Yup from 'yup'
import {Password} from 'Validations'

export const Validation = Yup.object({
  password: Password,
  verifyPassword: Yup.string()
    .required('Password is required.')
    .oneOf([Yup.ref('password'), null], 'Passwords must match'),
})
